module.exports = __webpack_public_path__ + "static/demo-screen-2-793d3cbbefefe3336e021c17579295c9.jpg";